import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import './helpers/foreachpoly'
import {Menu}from './shared/Menu';
import {Tabs}from './shared/Tabs';
import {Tooltip}from './shared/Tooltip';
import {Modal}from './shared/Modal';
import {AutoExpandTextArea}from './helpers/expandTextArea';
import {Cookies}from '../blocks/cookies/cookies';
import {FooterMenu}from '../blocks/footer-menu/footer-menu';
import {Banner} from '../blocks/new-site/new-site';
import 'slick-carousel';
import 'sumoselect/jquery.sumoselect.js';
const form = $('.b-form');

$(() => {
    svg4everybody();

    const banner = new Banner();

    $('.c-select').SumoSelect({
        placeholder: 'Выберите решение',
        captionFormat:'{0} выбрано',
        captionFormatAllSelected:'{0} всё выбрано!'
    });

    AutoExpandTextArea;
    if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined') {
        const multiplies = Array.from(document.querySelectorAll('.mix-blend-mode-multiply'));
        multiplies.forEach(item => {
            item.classList.add('mix-blend-mode-no');
        });
    }

    $('.js-solution-features').slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: (function() {
            return $('.b-solution-features__item').length;
        }()),
        slidesToScroll: (function() {
            return $('.b-solution-features__item').length;
        }()),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: (function() {
                        return $('.b-solution-features__item').length;
                    }()),
                    slidesToScroll: (function() {
                        return $('.b-solution-features__item').length;
                    }())
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.24,
                    slidesToScroll: 1
                }
            }]
    });
    const formInputs = form.find('.js-animate');

    formInputs.each((index, item) => {
        $(item).addClass('js-animate-loaded');
    });

    const HeaderMenu = new Menu('.js-header-menu');
    const tabs = new Tabs('.js-tabs');
    const tooltips = $('.js-tooltip');

    $.each(tooltips, function(index, item) {
        new Tooltip(item);
    });

    if ($('.js-open-modal').length){
        $.each($('.js-open-modal'), (index, item) => {
            new Modal(item);
        });
    }

    new Cookies('.js-cookies');
    const footerMenu = new FooterMenu('.js-footer-menu');
    function smallQuery(x) {
        if (x.matches) { // If media query matches
            footerMenu.init();
        } else {
            footerMenu.destruct();
        }
    }

    var x = window.matchMedia("(max-width: 767px)")
    smallQuery(x) // Call listener function at run time
    x.addListener(smallQuery) // Attach listener function on state changes

});




// WEBPACK FOOTER //
// ./app/scripts/app.js